import listActions from 'src/modules/enterpriseAlexaSkill/list/enterpriseAlexaSkillListActions';
import EnterpriseAlexaSkillService from 'src/modules/enterpriseAlexaSkill/enterpriseAlexaSkillService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'ENTERPRISEALEXASKILL_DESTROY';

const enterpriseAlexaSkillDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: enterpriseAlexaSkillDestroyActions.DESTROY_STARTED,
      });

      await EnterpriseAlexaSkillService.destroyAll([id]);

      dispatch({
        type: enterpriseAlexaSkillDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.enterpriseAlexaSkill.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/enterprise-alexa-skill');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: enterpriseAlexaSkillDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: enterpriseAlexaSkillDestroyActions.DESTROY_ALL_STARTED,
      });

      await EnterpriseAlexaSkillService.destroyAll(ids);

      dispatch({
        type: enterpriseAlexaSkillDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.enterpriseAlexaSkill.destroyAll.success'),
      );

      getHistory().push('/enterprise-alexa-skill');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: enterpriseAlexaSkillDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default enterpriseAlexaSkillDestroyActions;
